import React from "react";
/* import { Row } from "antd";
import { useIntl } from "react-intl";

import Service from "./service"; */

const EkServices = ({ disabled, initialServices, getFieldDecorator }) => {
  //const intl = useIntl();
  return (
    <>
      {/* <Service
          disabled={disabled}
          fieldName="deliveryInformation"
          label={intl.formatMessage({
            id: "consignment.services.iod",
            defaultMessage: "Informace o dodání (IOD)",
          })}
          getFieldDecorator={getFieldDecorator}
          initialValue={initialServices && initialServices.deliveryInformation}
        />
        <Service
          disabled={disabled}
          fieldName="deliveryProof"
          label={intl.formatMessage({
            id: "consignment.services.pod",
            defaultMessage: "Doklad o dodání (POD)",
          })}
          getFieldDecorator={getFieldDecorator}
          initialValue={initialServices && initialServices.deliveryProof}
        />
        <Service
          span={11}
          offset={6}
          disabled={disabled}
          fieldName="extraInsurance"
          className="services-form-service-special"
          label={intl.formatMessage({
            id: "consignment.services.extraInsurance",
            defaultMessage:
              "Připojištění zásilky na 110 % obchodní hodnoty zboží",
          })}
          getFieldDecorator={getFieldDecorator}
          initialValue={initialServices && initialServices.extraInsurance}
        />
        <Service
          disabled={disabled}
          fieldName="customsClearance"
          label={intl.formatMessage({
            id: "consignment.services.customsClearance",
            defaultMessage: "Celní odbavení",
          })}
          getFieldDecorator={getFieldDecorator}
          initialValue={initialServices && initialServices.customsClearance}
        />
        <Service
          disabled={disabled}
          fieldName="deliveryAgainstDocuments"
          label={intl.formatMessage({
            id: "consignment.services.deliveryAgainstDocuments",
            defaultMessage: "Dodání proti dokumentům",
          })}
          getFieldDecorator={getFieldDecorator}
          initialValue={
            initialServices && initialServices.deliveryAgainstDocuments
          }
        /> */}
    </>
  );
};

export default EkServices;
